//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { memorialCateCreateApi, memorialCateDeleteApi, memorialCateEditApi, memorialCateListApi } from '@/api/user';
export default {
  name: 'MenuTree',
  components: {
    dialogForm: function dialogForm() {
      return import('./dialog-form');
    }
  },
  props: {},
  data: function data() {
    return {
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      focusShow: false,
      recentlyShow: true,
      treeData: [],
      activeValue: '',
      formBoxConfig: {},
      id: 0,
      nodeIndex: null,
      rolesConfig: []
    };
  },
  watch: {
    treeData: {
      handler: function handler(nVal, oVal) {
        var _this = this;
        this.$nextTick(function () {
          var value = _this.id;
          _this.$refs.tree.setCurrentKey(value);
        });
      },
      deep: true
    }
  },
  mounted: function mounted() {
    this.onRecently();
    this.menuList();
  },
  methods: {
    //新建按钮
    handleCommand: function handleCommand(command) {
      switch (command) {
        case 'note':
          var data = {
            title: this.$t('calendar.placeholder03'),
            content: this.$t('calendar.placeholder04'),
            pid: this.id == '' ? 0 : this.id
          };
          if (this.recentlyShow) {
            this.$emit('createNote', data);
            this.recentlyShow = false;
            this.focusShow = true;
            this.handleClick(1);
          } else {
            this.$emit('createNote', data);
          }
          break;
        case 'folder':
          this.addCate(2);
          break;
      }
    },
    // 最近使用
    onRecently: function onRecently() {
      this.focusShow = false;
      this.recentlyShow = true;
      this.$refs.tree.setCurrentKey();
      this.$emit('onRecently');
    },
    // tree节点点击
    handleClick: function handleClick(node, data) {
      this.recentlyShow = false;
      if (node == 1) {
        this.focusShow = true;
        this.id = '';
        this.$refs.tree.setCurrentKey();
      } else {
        this.focusShow = false;
        this.id = node.id;
      }
      this.$emit('frameId', this.id);
    },
    // 编辑窗口显示
    handleShow: function handleShow(value) {
      this.activeValue = value;
    },
    // 编辑窗口隐藏
    handleHide: function handleHide() {
      this.activeValue = '';
    },
    menuList: function menuList() {
      var _this2 = this;
      memorialCateListApi().then(function (res) {
        _this2.treeData = [];
        if (res.data !== undefined) {
          _this2.treeData = res.data.tree;
          if (_this2.treeData.length > 0 && _this2.id === 0) {}
        }
      });
    },
    // 添加分类
    addCate: function addCate(type, data) {
      var _this3 = this;
      var id = type === 1 ? this.id : 0;
      memorialCateCreateApi(id).then(function (res) {
        _this3.formBoxConfig = {
          title: res.data.title,
          width: '500px',
          method: res.data.method,
          action: res.data.action.substr(4)
        };
        if (type === 1) {
          _this3.closePopover(data.id);
        }
        _this3.rolesConfig = res.data.rule;
        _this3.$refs.dialogForm.open();
      });
    },
    // 修改分类
    addEdit: function addEdit(data) {
      var _this4 = this;
      memorialCateEditApi(data.id).then(function (res) {
        _this4.formBoxConfig = {
          title: res.data.title,
          width: '500px',
          method: res.data.method,
          action: res.data.action.substr(4)
        };
        _this4.closePopover(data.id);
        _this4.rolesConfig = res.data.rule;
        _this4.$refs.dialogForm.open();
      });
    },
    // 删除
    handleDelete: function handleDelete(item) {
      var _this5 = this;
      this.$modalSure(this.$t('calendar.placeholder08')).then(function () {
        memorialCateDeleteApi(item.id).then(function (res) {
          _this5.menuList();
        });
      });
    },
    closePopover: function closePopover(id) {
      this.$refs["pop-".concat(id)].doClose();
    },
    openPopover: function openPopover(id) {
      this.$refs["pop-".concat(id)].doShow();
    }
  }
};